import * as Sentry from '@sentry/browser';
import { get } from 'lodash';
import {
    EMAIL_TAKEN_MESSAGE,
    EMAIL_VALIDATION_RESULT,
} from 'src/Booking/components/CreateUsernameForm/constants';

export const fetchEmailValidation = async (email) => {
    const apiHost = process.env.API_HOST || '';
    const validationEndpoint = `${apiHost}/api/web/2/patient/validateemail`;
    const fetchData = {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: email }),
        credentials: 'include',
    };

    try {
        const resp = await fetch(validationEndpoint, fetchData);

        if (resp.status === 200) {
            return EMAIL_VALIDATION_RESULT.UNUSED;
        } else if (resp.status === 400) {
            const val = await resp.json().catch(() => {});
            const fields = get(val, 'error.fields', []);
            const messages = fields.map((field) => field.message);

            if (messages.includes(EMAIL_TAKEN_MESSAGE)) {
                return EMAIL_VALIDATION_RESULT.USED;
            }
        }
    } catch (e) {
        Sentry.captureException(e);
    }

    return EMAIL_VALIDATION_RESULT.UNKNOWN;
};
